import { IProcessDetails } from '../../../../../../../../../../shared/interfaces/IFootprint';
import { PROCESS_DROPDOWN_OPTIONS, ProcessIdsMap } from '../../PcfWizard.type';
import IndividualProcessForm from './components/individual-process-form/IndividualProcessForm';
import InjectionMoldingForm from './components/injection-molding-form/InjectionMoldingForm';
import TransportProcessForm from './components/transport-process-form/TransportProcessForm';

type ProcessCardProps = {
  index: number;
  process: IProcessDetails;
  onDelete: (showConfirmationDialog: boolean) => void;
};

const ProcessCard = ({ index, process, onDelete }: ProcessCardProps) => {
  if (!process) {
    return <></>;
  }

  // Render card content based on its type
  const renderContent = () => {
    return (
      <div className='bg-white px-5 py-4 border-round-2xl flex flex-column w-full'>
        {process.process_id === ProcessIdsMap[PROCESS_DROPDOWN_OPTIONS.INJECTION_MOLDING] && (
          <InjectionMoldingForm
            processIndex={index}
            name='processes'
            key={index}
            onDelete={onDelete}
          />
        )}
        {process.process_id === ProcessIdsMap[PROCESS_DROPDOWN_OPTIONS.INDIVIDUAL_PROCESS] && (
          <IndividualProcessForm
            processIndex={index}
            name='processes'
            key={index}
            onDelete={onDelete}
          />
        )}
        {process.process_id === ProcessIdsMap[PROCESS_DROPDOWN_OPTIONS.TRANSPORT_PROCESS] && (
          <TransportProcessForm
            processIndex={index}
            name='processes'
            key={index}
            onDelete={onDelete}
          />
        )}
      </div>
    );
  };

  return renderContent();
};

export default ProcessCard;
